import { useContext } from 'react';
import LiffContext from '../contexts/LiffContext';

const useLiff = () => useContext(LiffContext);

export default useLiff;
